(function taListAnchorContainer() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'ta_list-anchor-container';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  $(() => {
    const $listAnchor = $('.list-anchor-container');
    const $listAnchorMenu = $('.list-anchor-menu');
    const $listAnchorItem = $('.list-anchor-menu__item');
    const marginTop = 20;
    const Offset = 10;
    const listAnchorTop = $listAnchor.offset().top;
    const listAnchorMarginTop = Number($listAnchor.css('margin-top').replace('px', ''));
    const listAnchorSectionMarginTop = Number(
      $($listAnchor.find('[id^="section-"]')[0]).css('margin-top').replace('px', ''),
    );

    function calculateHeaderHeight() {
      const messageBannerHeight = isCompExists('message-banner')
        ? $('.message-banner').innerHeight()
        : 0;
      const headerHeight = isCompExists('header') ? $('#header-anchor').innerHeight() : 0;

      return headerHeight + messageBannerHeight;
    }

    function listAnchorMenuFixedPos() {
      const isMobile =
        getComputedStyle($listAnchorMenu[0]).getPropertyValue('--is-mobile').trim() === 'true';
      $listAnchorMenu
        .removeClass('pos-bottom pos-top')
        .addClass('pos-fixed')
        .css({ top: isMobile ? '' : calculateHeaderHeight() + marginTop });
    }

    function listAnchorMenuTopPos() {
      $listAnchorMenu.addClass('pos-top').removeClass('pos-bottom pos-fixed').css({ top: '' });
    }

    function listAnchorMenuBottomPos() {
      $listAnchorMenu.addClass('pos-bottom').removeClass('pos-top pos-fixed').css({ top: '' });
    }

    function listAnchorMenuPosHandler() {
      const scrollPos = $(window).scrollTop();

      if (scrollPos >= $listAnchor.height()) {
        listAnchorMenuBottomPos();
      } else if (scrollPos <= listAnchorTop + calculateHeaderHeight()) {
        listAnchorMenuTopPos();
      } else {
        listAnchorMenuFixedPos();
      }
    }

    const resizeObserver = new ResizeObserver(() => {
      listAnchorMenuPosHandler();
    });
    const listAnchorSectionIntersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const { isIntersecting } = entry;
        const $listAnchorLinkSection = $listAnchor.find(`[href='#${entry.target.id}'`);
        const entryTargetMarginTop = Number($(entry.target).css('margin-top').replace('px', ''));
        const scrollPos = $(window).scrollTop();
        const isHigherThenTop =
          scrollPos + calculateHeaderHeight() + listAnchorMarginTop + entryTargetMarginTop >=
          $(entry.target).offset().top;
        const listAnchorLinkSectionClassToogler = {
          true: () => $listAnchorLinkSection.addClass('active'),
          false: () => $listAnchorLinkSection.removeClass('active'),
        };
        if (!isIntersecting) {
          listAnchorLinkSectionClassToogler[isHigherThenTop]();
        }
        listAnchorMenuPosHandler();
      },
      {
        rootMargin: `-${calculateHeaderHeight() + listAnchorMarginTop + Offset}px`,
      },
    );
    const listAnchorItersection = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const { isIntersecting } = entry;
        const scrollPos = $(window).scrollTop();
        if (!isIntersecting) {
          scrollPos >= $listAnchor.height() && listAnchorMenuBottomPos();
        } else {
          scrollPos <= $listAnchor.height() && listAnchorMenuTopPos();
        }
      },
      {
        rootMargin: `-${
          calculateHeaderHeight() + listAnchorMarginTop + listAnchorSectionMarginTop
        }px`,
      },
    );
    const listAnchorMenuIntersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const { isIntersecting } = entry;
        const scrollPos = $(window).scrollTop();
        if (!isIntersecting) {
          if (scrollPos >= $listAnchor.height()) {
            listAnchorMenuBottomPos();
          } else if (scrollPos <= $listAnchor.offset().top) {
            listAnchorMenuTopPos();
          } else {
            listAnchorMenuFixedPos();
          }
        } else {
          scrollPos >= $listAnchor.height() && listAnchorMenuFixedPos();
        }
      },
      {
        rootMargin: `-${
          calculateHeaderHeight() + listAnchorMarginTop + listAnchorSectionMarginTop
        }px`,
      },
    );

    resizeObserver.observe($('body')[0]);
    $listAnchor.find('[id^="section-"]').each((i, el) => {
      listAnchorSectionIntersectionObserver.observe(el);
    });
    listAnchorItersection.observe($listAnchor[0]);
    listAnchorMenuIntersectionObserver.observe($listAnchorMenu[0]);

    $listAnchorMenu.find('.list-anchor-menu__sommaire-mobile').on('click', () => {
      $listAnchorMenu.toggleClass('open');
    });
    $listAnchorMenu.find('.list-anchor-menu__item').on('click', () => {
      $listAnchorMenu.removeClass('open');
    });
    $listAnchorItem.on('click', (el) => {
      const $this = el.target.hash;

      Foundation.SmoothScroll.scrollToLoc($this, {
        animationDuration: 10,
        animationEasing: 'linear',
        threshold: marginTop,
        offset: calculateHeaderHeight(),
      });
    });
  });
})();
